<template>
  <div :class="popup_class" @click="click_close_popup">
    <!--      <div  v-if="show_instructions" class="dummy text-md py-2 mt-8 mb-auto inline-block">&nbsp;</div>-->
    <div class="popup_video_container relative" v-if="!has_link">
      <div class="scroll-helper" @click="prevent_close($event)">
        <img :src="img_src" :style="img_style" />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1024 1024"
          class="img-map"
        >
          <a :href="link1" target="_blank">
            <polygon
              class="cls-1"
              fill="transparent"
              points="492.78 687.38 565.2 263.24 429.56 198.87 429.56 74.74 228.41 74.74 228.41 183.93 31.86 272.44 124.97 697.72 492.78 687.38"
            />
          </a>
          <a :href="link2" target="_blank">
            <polygon
              class="cls-1"
              fill="transparent"
              points="590.48 865.54 770.94 512 972.09 608.07 1001.98 533.36 912.32 460.94 828.41 373.59 872.09 302.32 868.64 256.35 623.82 256.35 603.13 401.17 546.8 417.26 512 608.07 524.97 678.18 492.78 854.05 590.48 865.54"
            />
          </a>
          <a :href="link3" target="_blank">
            <polygon
              class="cls-1"
              fill="transparent"
              points="603.13 868.99 775.54 517.26 1018.07 642.55 1018.07 709.22 868.64 1000.02 603.13 868.99"
            />
          </a>
        </svg>
      </div>
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
    </div>
    <div class="popup_video_container relative" v-if="has_link">
      <div class="option-bar" v-if="is_closable" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <div class="scroll-helper" @click="prevent_close($event)">
        <a :href="link_src" target="_blank"
          ><img :src="img_src" :style="img_style"
        /></a>
      </div>
    </div>

    <!--      <div v-if="show_instructions" class="app-popup-instructions text-gray-100 text-sm px-12 py-2 text-md w-18 rounded-full inline-block mb-8 bg-black self-center mt-auto">-->
    <!--        <span>The image will close automatically after a few seconds.</span>-->
    <!--      </div>-->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ImagePopup",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "sections_content",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/popups/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/image";

      return str;
    },
    img_style() {
      let style = {};

      if ("undefined" != typeof this.getCurrentSectionContent().style) {
        style = this.getCurrentSectionContent().style;
      }
      return style;
    },
    img_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/" +
        this.getCurrentSectionContent().src
      );
    },
    link_src() {
      return this.getCurrentSectionContent().link;
    },
    has_link() {
      return (
        "undefined" != typeof this.getCurrentSectionContent().link &&
        this.getCurrentSectionContent().link.length > 0
      );
    },
    link1() {
      return this.getCurrentSectionContent().links.b1;
    },

    link2() {
      return this.getCurrentSectionContent().links.b2;
    },

    link3() {
      return this.getCurrentSectionContent().links.b3;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    },
    show_instructions() {
      return this.$store.state.app_state != 2;
    },
    is_video_src() {
      return (
        undefined != typeof this.$store.state.popup_img_src &&
        this.$store.state.popup_img_src != ""
      );
    },
    popup_class() {
      return (
        "brochure-popup popup " + this.extra_css_class + " " + this.loading
      );
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    },
    extra_css_class() {
      let extra = this.getCurrentSectionContent().extra_css_class;
      return extra || "";
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    close_popup(e) {
      console.log("close popup");
      //if(e)
      //e.preventDefault();

      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_img_src, 10)
        );
      }

      this.$bus.$emit("send_interactive_msg", "popupClosed", 1);
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },

    onPopupTimeout() {
      if (this.$store.state.app_state === 0) {
        //this.$bus.$emit('send_unity_msg', 'OnContinueTransition', this.$store.state.popup_img_src)
        console.log("requesting closing popup by timeout");
        //this.$bus.$emit('on-transition-started', '6');
        // this.$store.dispatch('set_popup_state', '');
        this.close_popup(null);
      }
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
}
.popup iframe {
  width: 95%;
  height: 90%;
  margin-top: 5%;
}

.option-bar {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
  cursor: pointer;
}
.popup_video_container {
  align-self: center;
  margin: 0 0;
  max-width: 90vw;
}
.popup_video_container img {
  max-height: 90vh;
  object-fit: contain;
  -webkit-user-drag: none;
  user-drag: none;
}
.popup_video_container a {
  -webkit-user-drag: none;
  user-drag: none;
}
.scroll-helper {
  max-height: 90vh;
  overflow-y: auto;
}

/* custom additional classes */
.circle_popup .option-bar {
  width: 100%;
  height: 120px;
  right: auto;
  top: 3%;
  left: 0;
}
.circle_popup .option-bar .close-link {
  width: 120px;
  height: 120px;
  background: none;
  background-size: auto;
}

.top_right_close .option-bar {
  width: 120px;
  height: 120px;
  right: 0;
  top: 0;
}
.top_right_close .option-bar .close-link {
  width: 120px;
  height: 120px;
  background: none;
  background-size: auto;
}
.top_right_close.small_close .option-bar {
  width: 67px;
  height: 67px;
}
.top_right_close.small_close .close-link {
  width: 67px;
  height: 67px;
}

.full_close .option-bar {
  width: 100%;
  height: 100%;
  top: 0;
  rigth: 0;
}
.full_close .close-link {
  width: 100%;
  height: 100%;
  background: none;
  background-size: auto;
}

.form-popup .scroll-helper img {
  max-width: 1024px;
  height: auto;
}

.img-map {
  position: absolute;
  top: 0;
  left: 0;
}

@media only screen and (max-width: 1110px) {
  .popup .vueperslides__arrows--outside {
    display: none;
  }
  .popup .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>
<style>
.img-map .cls-1:hover {
  fill: rgba(255, 255, 255, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/popups/BrochurePopup.vue